import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui';
import './Topfold.css';

const Topfold = () => {
    const navigate = useNavigate();

    return (
        <section className="topfold-section anchor-target" id="top">
            <div className="topfold-media" aria-hidden="true">
                <div className="topfold-background" />
                <div className="topfold-gradient" />
            </div>

            <div className="topfold-container">
                <motion.div
                    className="topfold-content"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: [0.6, -0.05, 0.01, 0.99] }}
                >
                    <motion.p
                        className="topfold-eyebrow"
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.05 }}
                    >
                        MotionSpace · Consulting · Capital · Technology
                    </motion.p>
                    <motion.h1
                        className="topfold-heading"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        Navigate complexity. Build lasting change.
                    </motion.h1>
                    <motion.p
                        className="topfold-subhead"
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.55, delay: 0.16 }}
                    >
                        We bring change management consulting, angel and private-equity capital, and hands-on automation,
                        AI, and analytics—so your organisation can decide faster and make change stick.
                    </motion.p>

                    <motion.div
                        className="topfold-buttons"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.22 }}
                    >
                        <Button
                            variant="primary"
                            size="md"
                            onClick={() => navigate('/contact')}
                            className="topfold-btn-primary"
                        >
                            Contact us
                        </Button>
                        <Button variant="outline" size="md" onClick={() => navigate('/services')}>
                            View services
                        </Button>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default Topfold;
